export const getSpaceForCurrentLanguage = () => {
  const currentLocale = I18n.currentLocale();
  return APP_CONSTANTS.LANGUAGES_WITHOUT_SPACES.includes(currentLocale) ? '' : ' ';
};
